<template>

    <v-section :name="name" :expanded="expanded">
        <v-input size="sm" placeholder="person@mycompany.com" :model="action[type]" @input="updateAction(type, $event)" />
    </v-section>

</template>

<script>

import Section from './Section';

export default {

    components: {
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'bcc',
        },
    },

    computed: {

        action() {
            return this.$store.getters['builder/action'];
        },

        name() {
            return this.type === 'bcc' ? 'BCC' : 'Reply To';
        },

    },

    methods: {

        updateAction(key, value) {
            let action = this.action;
            this.$set(action, key, value);
            this.$store.commit('builder/setAction', action);
        },

    },

}

</script>